module.exports = __webpack_public_path__ + "43c7561c261860e4cc658eebbb1a3079.svg";